// External libs
import { createSelector } from 'reselect';
// Consts
import { textIds } from '../consts';
import { SupportSuggestion } from '../../../interfaces';
// Tools
import { formatMessage } from '../../../intl/intl';
// Selectors
import { selectors as stockOutIssueSuggestionsDialogSelectors } from '../../../redux/stock-out-issue-suggestions-dialog';
import { Option, utils } from '../../common/boxes/custom-clickable-box-list';
// Store
import appStore from '../../../redux/stores/app.store';
// Transpilers
import supportSuggestionTranspiler from '../../../transpilers/support-suggestion-transpiler';
// Actions
import EventActions from '../../../redux/actions/event-actions';

const selectOptions = createSelector<
  number,
  any,
  SupportSuggestion[],
  Option[]
>(
  stockOutIssueSuggestionsDialogSelectors.selectOrderId,
  stockOutIssueSuggestionsDialogSelectors.selectSupportSuggestions,
  (orderId, supportSuggestions) => {
    const dispatch = appStore.getDispatch();
    return supportSuggestions.map((suggestion) => {
      const action = supportSuggestionTranspiler.getStockOutIssueAction(
        suggestion.id,
      );

      const onClick = async () => {
        const suggestionId = suggestion.id;
        EventActions.onClickSelectedSuggestion(orderId, suggestionId);
        await dispatch(action());
      };
      return utils.buildOption(
        suggestion.description,
        onClick,
        suggestion.title,
      );
    });
  },
);

const selectTitle = createSelector<any, number, string>(
  stockOutIssueSuggestionsDialogSelectors.selectOrderId,
  (orderId) => formatMessage(textIds.title, { orderId }),
);

const selectors = { selectOptions, selectTitle };

export default selectors;
